import {
  TableField,
  defaultCurrencyFormatter,
  defaultDateTimeFormatter,
} from "../../table-field";

const QtLicitada: TableField = {
  key: "QtLicitada",
  label: "Quantidade Licitada",
  tdClass: "align-middle",
  thClass: "text-center",
  sortable: false,
};

export const nmAtracao: TableField = {
  key: "NmAtracao",
  label: "Nome da Atração",
  tdClass: ["align-middle", "quebrarPorPalavra"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};

export const nmFiscalAtracao: TableField = {
  key: "NmFiscalAtracao",
  label: "Razão Social da Atração",
  tdClass: ["align-middle", "quebrarPorPalavra"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};

export const nmRazaoSocialRepresentante: TableField = {
  key: "NmRazaoSocialRepresentante",
  label: "Razão Social do Representante Legal",
  tdClass: ["align-middle", "quebrarPorPalavra"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};

export const dtInicio: TableField = {
  key: "DtInicio",
  label: "Data",
  tdClass: "align-middle",
  thClass: ["text-center", "quebrarPorPalavraHard"],
  sortable: false,
  formatter: defaultDateTimeFormatter,
};

export const duracao: TableField = {
  key: "VlDuracaoMinutos",
  label: "Duração (minutos)",
  tdClass: ["align-middle", "quebrarPorPalavra"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};

const vlAtracao: TableField = {
  key: "VlAtracao",
  label: "Valor Estimado",
  tdClass: "align-middle",
  thClass: ["text-center", "quebrarPorPalavraHard"],
  sortable: false,
  formatter: defaultCurrencyFormatter,
};

export const cpfCnpjAtracaoArtistica: TableField = {
  key: "CdCpfCnpjAtracaoArtistica",
  label: "CPF/CNPJ Atração Artística",
  tdClass: ["align-middle", "quebrarPorPalavra"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};

export const cdCpfCnpjRepresentanteLegal: TableField = {
  key: "CdCpfCnpjRepresentanteLegal",
  label: "CPF/CNPJ do Representante Legal",
  tdClass: ["align-middle", "quebrarPorPalavra"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};

const atracaoLocal: TableField = {
  key: "FlAtracaoLocal",
  label: "Atração Local",
  tdClass: "align-middle",
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
  formatter: (val: string) => { return val === 'S' ? 'Sim' : 'Não' }
};

export const fieldsAtracaoArtistica: TableField[] = [
  nmAtracao,
  dtInicio,
  duracao,
  vlAtracao,
  atracaoLocal
];

export const fieldEdicaoAtracaoArtistica: TableField = {
  key: "actions",
  label: "Ações",
  tdClass: ["align-middle", "col-actions"],
  thClass: "text-center",
  sortable: false,
};

export const detalhes: TableField = {
  key: "detalhes",
  label: "Ver Detalhes",
  tdClass: ["align-middle", "w7remLg"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};
